import {
  VizixEventAction, VizixEventActivity, VizixEventCategory, VizixEventEventType,
  VizixEventSource, VizixEventStatus, VizixEventSubCategory
} from "../app/app.constants";

export class VizixEventItem {

  action: VizixEventAction;

  activity: VizixEventActivity;

  category: VizixEventCategory;

  count: number;

  description: string;

  detail: string;

  eventDate: number; // METADATA

  eventId: string;

  eventType: VizixEventEventType;

  remoteSource: string; // METADATA - UUID

  source: VizixEventSource; // METADATA

  status: VizixEventStatus;

  subCategory: VizixEventSubCategory;

  user: string; // METADATA

  userGroup: string; // METADATA

  userTenant: string; // METADATA


  /*constructor(action: VizixEventAction, activity: VizixEventActivity, category: VizixEventCategory, description: string,
              detail: string, eventDate: number, eventId: string, eventType: VizixEventEventType, remoteSource: string,
              source: VizixEventSource, status: VizixEventStatus, subCategory: VizixEventSubCategory, user: string,
              userGroup: string, userTenant: string) {
    this.action = action;
    this.activity = activity;
    this.category = category;
    this.description = description;
    this.detail = detail;
    this.eventDate = eventDate;
    this.eventId = eventId;
    this.eventType = eventType;
    this.remoteSource = remoteSource;
    this.source = source;
    this.status = status;
    this.subCategory = subCategory;
    this.user = user;
    this.userGroup = userGroup;
    this.userTenant = userTenant;
  }*/

  public fromBaseVizixEvent(eventDate: number, remoteSource: string, source: VizixEventSource,
                            user: string, isError:boolean, userGroup: string, userTenant: string): VizixEventItem {
    this.action = VizixEventAction.NONE;
    this.activity = VizixEventActivity.NONE;
    this.category = VizixEventCategory.NONE;
    this.description = '';
    this.detail = '';
    this.eventDate = eventDate;
    this.eventId = '';
    this.eventType = VizixEventEventType.NONE;
    this.remoteSource = remoteSource;
    this.source = source;
    this.status = isError ? VizixEventStatus.FAILURE : VizixEventStatus.SUCCESS;
    this.subCategory = VizixEventSubCategory.NONE;
    this.user = user;
    this.userGroup = userGroup;
    this.userTenant = userTenant;
    return this;
  }

  public setAsError(errorMessage?: string){
    this.status = VizixEventStatus.FAILURE;
    if(errorMessage){
      this.detail = errorMessage;
    }
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/VizixEventItem.ts